import React from "react";

const AnimationPrevious = ( animate, animate_class, pageset, pageview) => {
    let element = document.getElementsByClassName(animate_class);
    for (let i = 0; i < element.length; i++) {
        element[i].classList.add(animate); // add animate class
    }
    setTimeout(()=>{
        for (let i = 0; i < element.length; i++) {
            if(element[i].classList.contains(animate)){element[i].classList.remove(animate)}// remove class
        }
        pageview.Set(pageset);// set next page view after performing old page animation
    },300)
}
export {AnimationPrevious}